import { STATES } from "components/form/fields/UploaderField/constants";

import { Image } from "./types";

const FILE_PROGRESS_TOTAL = 100;

export const initialFile = (value = "", id = 0): Image => ({
  id: id,
  loaded: value ? FILE_PROGRESS_TOTAL : 0,
  total: FILE_PROGRESS_TOTAL,
  status: value ? STATES.uploaded : STATES.idle,
  url: value,
  error: null,
  name: "",
});
